module.exports = __webpack_public_path__ + "img/BlinkArt_Sword4_Red.004e1d92.png";